import { memo, type SVGProps } from 'react'

const SvgBook = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.333 26a3.333 3.333 0 0 1 3.334-3.333h18M5.333 26a3.333 3.333 0 0 0 3.334 3.333h18V2.667h-18A3.333 3.333 0 0 0 5.333 6v20Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
const Memo = memo(SvgBook)
export default Memo
